import React, { useEffect, useState } from 'react';
import AboutUs from './AboutUs';
import FeatureCard from './FeatureCard';
import About2 from './About2';
import './App.css';
import OnlyForm from './OnlyForm';
import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';




import Footer from './Footer';


const QR = () => {


  const links = [
    {
      label: "Wasala Lake - Our Menu",
      url: `${window.location.origin}/pdf/Menu1.pdf`,
    },
  ];



  return (

  <div className="dashboard">


    <div className="qr-container">
      <h2>Scan QR Code</h2>

      <div className="qr-list">
        {links.map((link, index) => (
          <div key={index} className="qr-item">
            <QRCodeCanvas
              value={link.url}
              size={250}
              fgColor="#000000"
              bgColor="#FFF9C4"
            />
            <p>{link.label}</p>
          </div>
        ))}
      </div>

    </div>
  </div>

  );
};

export default QR;